export enum CreditCheckProviderEnum {
  VALID_8 = 1,
  CHECKBOARD = 2
}
